import React from 'react'

const NavContents = () => {
  return (
    <>
      <a href='#introduction' className='options'>Introduction</a>
      <a href='#portfolio' className='options'>Technologies</a>
      <a href='#experience' className='options'>Experience</a>
      <a href='#cover-page' className='options'>Websites</a>
      <a href='#contacts' className='options'>Contact</a>
    </>
  )
}

export default NavContents